module.exports = __webpack_public_path__ + "static/media/fastfood profilo.7ab9d426.svg";